// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__uxbRj","textarea":"styles_textarea__1priH"};